import type { ValueOf } from './ValueOf';

export const ApprovalStatus = {
  APPROVAL_PENDING: 'APPROVAL_PENDING',
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  REJECTED: 'REJECTED',
} as const;

export type ApprovalStatus = ValueOf<typeof ApprovalStatus>;
